import React, { useState } from "react";
import { Card, CardBody, CardTitle, Row, Col } from "reactstrap";
import { TextField, MenuItem, Button } from "@mui/material";
import moment from "moment";
import Swal from "sweetalert2";

function BranchDateFilter({
  branchList = [],
  branch,
  from_date,
  to_date,
  setBranch,
  setStartDate,
  setEndDate,
  onSubmit,
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (moment(to_date).isBefore(moment(from_date))) {
      Swal.fire({
        icon: "error",
        title: "Invalid Date Range",
        text: "To Date cannot be before From Date",
        confirmButtonColor: "#d33",
        confirmButtonText: "OK",
      });
      return;
    }
    const payload = {
      body: { branch_id: branch, from_date, to_date },
    };
    if (onSubmit) onSubmit(payload);
  };

  return (
    <Card className="card-stats mb-4 mb-xl-0">
      <CardBody>
        <Row className="align-items-center">
          <Col md={3}>
            <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
              Select Branch
            </CardTitle>
            <TextField
              fullWidth
              variant="outlined"
              select
              size="small"
              label="Branch"
              value={branch}
              onChange={(e) => setBranch(e.target.value)}
            >
              <MenuItem value="all">All</MenuItem>
              {branchList.map((b) => (
                <MenuItem key={b.id} value={b.id}>
                  {b.branch_name}
                </MenuItem>
              ))}
            </TextField>
          </Col>

          <Col md={3}>
            <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
              From Date
            </CardTitle>
            <TextField
              fullWidth
              type="date"
              size="small"
              variant="outlined"
              value={from_date}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Col>

          <Col md={3}>
            <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
              To Date
            </CardTitle>
            <TextField
              fullWidth
              type="date"
              size="small"
              variant="outlined"
              value={to_date}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Col>

          <Col md={3} className="text-right mt-3">
            <Button
              color="success"
              variant="contained"
              size="large"
              type="submit"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default BranchDateFilter;
